import { Container, Paper } from '@mui/material';
import { PropsWithChildren } from 'react';
import { HeaderPublic } from 'shared/header';
import { SxProps, Theme } from '@mui/material';

const containerStyles: SxProps<Theme> = {
  marginTop: '30px',
};

export function PublicLayout({ children }: PropsWithChildren<{}>) {
  return (
    <div>
      <HeaderPublic />
      <Container sx={containerStyles} maxWidth={false}>
        <Paper>{children}</Paper>
      </Container>
    </div>
  );
}
